import React from 'react'
import { useTranslation } from 'react-i18next'
import { TileTextApp, TileTextStyle, TileTextWebContainer } from './style'

interface IProps {
  isWeb: boolean
  title: string
}

export const TileText = ({ isWeb, title }: IProps) => {
  const { t } = useTranslation()
  if (isWeb) {
    return (
      <TileTextWebContainer>
        <TileTextStyle>{t(`activities;;${title}`)}</TileTextStyle>
      </TileTextWebContainer>
    )
  }
  return <TileTextApp>{t(`activities;;${title}`)}</TileTextApp>
}
